export const STEPS = {
  INSURED: "insured",
  LOCATIONS: "locations",
  REQUIREMENTS: "requirements",
  SUBLIMITS: "sublimits",
};

export default STEPS;
